import React from "react";
import Navbar from "../Navbar/index";
import SectionTitle from "../SectionTitle";
import PersonalInfo from "../PersonalInfo";
import { motion } from "framer-motion";
import SkillArea from "../Skills";

const AboutSection = () => {
  const desc = "I DESIGN AND CODE BEAUTIFUL THINGS, AND I LOVE WHAT I DO.";
  const variants = {
    hidden: { opacity: 0, x: -1000, y: 0 },
    enter: { opacity: 1, x: 0, y: 0 },
    exit: { opacity: 1, x: 0, y: -200 },
  };
  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="enter"
      exit="exit"
      transition={{ type: "linear", duration: 0.5 }}
    >
      <section className="about_page">
        <div className="container">
          <Navbar activeLi2={"activeLi"} />
          <SectionTitle sectitle={"About"} clrTtle="Me" secDesc={desc} />
          <PersonalInfo />
        </div>
      </section>
      <SkillArea />
    </motion.div>
  );
};

export default AboutSection;
